import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { images, volumes } from "../../data/content";
export function Volumes() {
  return <section className="w-full bg-paper px-5 py-16 md:py-24" data-id="element-310" data-mp="2wzp04ok8crc6">
      <div className="mx-auto max-w-3xl" data-id="element-311" data-mp="2t07vtygji08l">
        <SectionHeading eyebrow="Let me show you what's inside" title="6 practical premium volumes. Each with a specific purpose." data-id="element-312" data-mp="2sz57nyalqbwd" />
        <p className="mt-4 text-center text-[17px] text-ink/75 md:text-lg" data-id="element-313" data-mp="2j9vbo7cn092z">
          I didn't want to create another endless online course. So I organized everything into a clear path.
        </p>
        <img src={images.mainMockup} alt="The six volumes of The Aroma Lab" className="-mx-5 mt-6 w-[calc(100%+2.5rem)] max-w-none md:mx-auto md:w-full md:max-w-2xl" data-id="element-314" data-mp="29bpc3weazf1a" />

        <ol className="mt-10 space-y-6" data-id="element-315" data-mp="20b9a6rd7kfyj">
          {volumes.map(v => <li key={v.numeral} className="overflow-hidden rounded-3xl bg-cream" data-id="element-316" data-mp="20d3uq4kki623">
              <div className="flex items-center gap-4 px-6 py-5" style={{
            backgroundColor: v.color
          }} data-id="element-317" data-mp="334bb3b9rxdvi">
                <span className="font-display text-4xl text-brand-deep md:text-5xl" data-id="element-318" data-mp="37xnnmn16hu7w">{v.numeral}</span>
                <div data-id="element-319" data-mp="2u6sj1mxppza4">
                  <p className="text-[12px] font-bold uppercase tracking-widest text-brand-deep/70" data-id="element-320" data-mp="2y6j8nnbi69d2">Volume {v.numeral}</p>
                  <h3 className="font-serif text-2xl font-bold leading-tight text-brand-deep md:text-3xl" data-id="element-321" data-mp="3lvm1zsfi1qne">{v.title}</h3>
                </div>
              </div>
              <div className="px-6 py-6" data-id="element-322" data-mp="3qt48lc61nts8">
                <p className="text-[17px] leading-relaxed text-ink/85" data-id="element-323" data-mp="3cw8numgfkdwc">{v.body}</p>

                {v.listType === "chips" && <ul className="mt-4 flex flex-wrap gap-2" data-id="element-324" data-mp="3hsz1z48oczf4">
                    {v.list.map(item => <li key={item} className="rounded-full border border-brand-sage/40 bg-paper px-3 py-1.5 text-sm font-medium text-brand-olive" data-id="element-325" data-mp="21ez56254lpw3">
                        {item}
                      </li>)}
                  </ul>}

                {v.listType === "steps" && <ol className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-326" data-mp="7251axm68iat">
                    {v.list.map((item, i) => <li key={item} className="flex items-center gap-3 rounded-xl bg-paper px-4 py-3 text-[15px] text-ink/90" data-id="element-327" data-mp="3ud4ev9xmei92" data-mpi={i}>
                        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-olive text-sm font-bold text-cream" data-id="element-328" data-mp="3pebaq84843lk">
                          {i + 1}
                        </span>
                        {item}
                      </li>)}
                  </ol>}

                {v.listType === "checks" && <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-329" data-mp="1do8te5t4p3gn">
                    {v.list.map(item => <li key={item} className="flex gap-2 text-[16px] text-ink/90" data-id="element-330" data-mp="19mngikglgp6g">
                        <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-cta" aria-hidden="true" data-id="element-331" data-mp="2rl1yjh67mcmm" />
                        {item}
                      </li>)}
                  </ul>}

                <p className="mt-5 border-l-4 border-brand-sage pl-4 font-serif text-lg font-semibold italic leading-snug text-brand-olive" data-id="element-332" data-mp="31behj4ydlxqn">
                  {v.closing}
                </p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12" data-id="element-333" data-mp="28o0o3gtvzkba">
          <CtaButton label="I Want All 6 Volumes" data-id="element-334" data-mp="2djzawzzkgu9l" />
        </div>
      </div>
    </section>;
}